var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_61)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99727 0L8.80081 0.667734V20.0438L8.99727 20.2399L17.9914 14.9235L8.99727 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99734 0L0.00317383 14.9235L8.99734 20.24V10.8354V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99727 21.9429L8.88657 22.0779V28.9801L8.99727 29.3034L17.9968 16.6292L8.99727 21.9429Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99734 29.3033V21.9428L0.00317383 16.629L8.99734 29.3033Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99725 20.2399L17.9913 14.9236L8.99725 10.8355V20.2399Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00317383 14.9235L8.9972 20.2399V10.8354L0.00317383 14.9235Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 29.31,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9963,
    height: 29.31,
    fill: "white",
    transform: "translate(0.00183105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.cdf393b62fa04ee7059e871749434948.svg";
export { ForwardRef as ReactComponent };